import { TextField } from "@mui/material";
import React from "react";

const MeetingInput = ({ label, title, setTitle, type = "text", autoComplete }) => {
  return (
    <TextField
      label={label}
      variant="outlined"
      type={type}
      autoComplete={autoComplete}
      fullWidth
      required
      value={title}
      onChange={(e) => setTitle(e.target.value)}
     /* sx={{
      "&:hover .MuiOutlinedInput-notchedOutline": {
        borderColor: "#acd2f0", 
      },
  }}*/
    />
  );
};

export default MeetingInput;
